import { useEffect, useState } from 'react';

/**
 * Подписка на медиазапрос из JS.
 *
 * Нужен там, где от ширины зависит не стиль, а **содержимое**: CSS-медиазапрос
 * умеет спрятать элемент, но не умеет подменить текст. Первый случай — длинный
 * плейсхолдер поиска на главной демо (#1329): на 375px в поле помещается 223px
 * текста, а подсказка занимала 315px и обрывалась на полуслове.
 *
 * Для обычной адаптивной вёрстки хук не нужен — там медиазапрос в CSS-файле
 * компонента, как требует `DESIGN.md`.
 *
 * Подписка живая: поворот телефона и ресайз окна отрабатываются без
 * перезагрузки.
 *
 * Им же проверяется и `(prefers-reduced-motion: reduce)` там, где анимация
 * живёт в JS и медиазапрос до неё не достаёт. Отдельный хук
 * `usePrefersReducedMotion` существовал ради орба и снят вместе с ним
 * (#1329) — для CSS-анимаций медиазапрос в файле компонента по-прежнему
 * достаточен и предпочтителен.
 *
 * @param {string} query медиазапрос, например `'(min-width: 640px)'`
 * @returns {boolean} совпадает ли запрос сейчас
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    setMatches(mq.matches);
    const onChange = (e) => setMatches(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
